import React from 'react';
import { t } from 'Src/i18n';
import { useTrackEvent } from 'Tracking/tracking-api/useTrackEvent';
import { TRACK_EVENT_NAMES } from 'Tracking/constants';
import { AdditionalTransportFilterButton } from './AdditionalTransportFilterButton';
type AdditionalTransportFilterDurationRangeProps = {
  durationRanges: Array<TransportFilter>;
  updateFilters: (key: TransportFiltersKeys, value: string | TransportDateRange) => void;
};
export const AdditionalTransportFilterDurationRange = ({
  durationRanges,
  updateFilters,
}: AdditionalTransportFilterDurationRangeProps) => {
  const { trackClickEvent } = useTrackEvent();
  return (
    <div data-testid="AdditionalTransportFilterDurationRange" className="grid grid-rows-2 gap-10">
      <div className="flex items-center gap-10">
        {durationRanges.slice(0, 2).map((durationRange) => (
          <div key={`durationRange-${durationRange.value}`}>
            <AdditionalTransportFilterButton
              label={t(`faceting.filters.flightDuration.${durationRange.label}`)}
              isSelected={durationRange.isSelected}
              onClick={() => {
                trackClickEvent(TRACK_EVENT_NAMES.CLICK_TRANSPORT_LAYER, {
                  detail_click: 'filter_flight_time',
                });
                updateFilters('durationRanges', durationRange.value);
              }}
            />
          </div>
        ))}
      </div>
      <div className="flex items-center gap-10">
        {durationRanges.slice(2).map((durationRange) => (
          <div key={`durationRange-${durationRange.value}`}>
            <AdditionalTransportFilterButton
              label={t(`faceting.filters.flightDuration.${durationRange.label}`)}
              isSelected={durationRange.isSelected}
              onClick={() => {
                trackClickEvent(TRACK_EVENT_NAMES.CLICK_TRANSPORT_LAYER, {
                  detail_click: 'filter_flight_time',
                });
                updateFilters('durationRanges', durationRange.value);
              }}
            />
          </div>
        ))}
      </div>
    </div>
  );
};
